import { render, staticRenderFns } from "./showHklrHkgm.vue?vue&type=template&id=bd6bb88e"
import script from "./showHklrHkgm.vue?vue&type=script&lang=js"
export * from "./showHklrHkgm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports